import apiService from "../common/commonApi";

export const leaveConfig = {};

leaveConfig.getConfig = async (param) => {
    return apiService.Get("getConfig", param);
};

leaveConfig.updateConfig = async (param) => {
    return apiService.Post("updateConfig", param);
};
